(function(){
	'use strict';

	/**
	* Modal
	* The user needs to make a link and add a class of pop
	*/

	// Define the pre loader markup
	const loader = `
	<div class="spinner">
		<div class="bounce1"></div>
		<div class="bounce2"></div>
		<div class="bounce3"></div>
	</div>
	`;

	function checkURL(url) {
		return(url.match(/\.(jpeg|jpg|gif|png)$/) != null);
	}

	// See: https://getbootstrap.com/docs/4.3/components/modal/
	$('.pop').on('click', function(e) {

		// Prevent default actions
		e.preventDefault();

		// Get the link && the title
		var contentUrl = $(this).attr('href');
		var modalTitle = $(this).attr('title');

		// Sometimes the class ends up on an outer elements
		if( typeof(contentUrl) == 'undefined' ) {

			contentUrl = $(this).find('a').attr('href');
		}

		if( typeof(modalTitle) == 'undefined' ) {

			modalTitle = $(this).find('a').attr('title');
		}

		// Inject the title
		$('#smpModal .modal-title').html(modalTitle);

		// Inject the content
		if (checkURL(contentUrl)){
			$('#smpModal .modal-body').html('<div class="text-center"><img src="' + contentUrl + '" alt="' + modalTitle + '"></div>');
		} else {
			$('#smpModal .modal-body').load(contentUrl + ' .page-content', function() {
				// Apply a class
				$('#smpModal .modal-body').addClass('loaded');
			});
		}

		// Open the modal
		$('#smpModal').modal('show');

	});

	// When the modal closes
	$(document).on('hidden.bs.modal','#smpModal', function () {

		// Remove the tile
		$('#smpModal .modal-title').empty();
		// Add the loader back
		$('#smpModal .modal-body').html(loader);
		// Remove the loaded class
		$('#smpModal .modal-body').removeClass('loaded');
	});

}());
